import {
  PCCProgram,
} from 'dtos/pCCProgram';
import {
  PCCEnrollVariant,
} from 'pages/Dashboard/pages/Encounters/pages/VisitNote/components/PCC/EnrollDialog/types';

export type EnrollStep = 'programs' | 'recommendation' | 'attestation';

export function getEnrollSteps(
  variant: PCCEnrollVariant,
  selectedIncludesRTM: boolean,
): EnrollStep[] {
  if (variant === 'recommendation') {
    return ['recommendation', 'attestation'];
  }

  return selectedIncludesRTM
    ? ['programs', 'recommendation', 'attestation']
    : ['programs'];
}

export function selectionIncludesRTM(selectedPrograms: PCCProgram[]): boolean {
  return selectedPrograms.includes(PCCProgram.RTM);
}
